function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 9.5C1.5 8.94772 1.94772 8.5 2.5 8.5L6.5 8.5C7.05228 8.5 7.5 8.94772 7.5 9.5V19.5C7.5 20.0523 7.05228 20.5 6.5 20.5H2.5C1.94772 20.5 1.5 20.0523 1.5 19.5L1.5 9.5Z",
  stroke: "#D928DC"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5 2.55317C11.5 2.52494 11.5247 2.50309 11.5528 2.5066L12.5232 2.6279C14.2238 2.84047 15.5 4.28613 15.5 6V6V8.5H18.5722C20.5504 8.5 21.987 10.3809 21.4665 12.2894L20.1029 17.2894C19.7469 18.5945 18.5615 19.5 17.2086 19.5H15H10L8.5 18.5H7.5L7.5 10.5H8.5L11.5 6.5V2.55317Z",
  stroke: "#D928DC",
  strokeLinejoin: "round"
});

var SvgLike = function SvgLike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/like.1c82960f.svg";
export { ForwardRef as ReactComponent };